import type { Season } from '@/types/season';
import { daysUntilOpener, seasonStatus } from '@/utils/countdown-utils';
import { WEAPON_LABELS } from '@/utils/season-utils';

interface SeasonPillsProps {
  seasons: Season[];
  primarySeasonId: string;
  /** Called when the user taps a secondary pill — switches the hero to that season. */
  onSelectSeason: (seasonId: string) => void;
}

function getPillLabel(season: Season): string {
  const status = seasonStatus(season);
  const weaponLabel = WEAPON_LABELS[season.weaponType];

  if (status === 'active') {
    return `${weaponLabel} · Active`;
  }
  if (status === 'ended') {
    return `${weaponLabel} · Complete`;
  }
  // upcoming
  const days = daysUntilOpener(season.openerDate);
  return `${weaponLabel} · ${days}d`;
}

export function SeasonPills({ seasons, primarySeasonId, onSelectSeason }: SeasonPillsProps) {
  const secondary = seasons.filter((s) => s.id !== primarySeasonId);

  // When total season count is 0 or 1, render nothing
  if (seasons.length <= 1 || secondary.length === 0) return null;

  return (
    <div className="flex flex-row gap-2 flex-wrap" data-testid="season-pills">
      {secondary.map((season) => (
        <button
          key={season.id}
          type="button"
          onClick={() => onSelectSeason(season.id)}
          data-testid={`season-pill-${season.id}`}
          className="inline-flex items-center px-2.5 py-1 rounded-full text-body-xs font-medium bg-[var(--color-elevated)] text-[var(--color-text-secondary)] border border-[var(--color-border)] hover:bg-[var(--color-border)] transition-colors"
        >
          {getPillLabel(season)}
        </button>
      ))}
    </div>
  );
}
